import { useMemo, useState } from 'react';
import { TreeItemType } from '@/Components/TreeView/TreeView';
import { treeViewUtils } from '@/Utils';

export function useActiveLogisticTypesTreeViewOptions() {
  const logisticTypes: TreeItemType<number>[] = [];

  const [selectedLogisticTypes, setSelectedLogisticTypes] = useState<number[]>(() => {
    const selectedKeys = treeViewUtils.getSelectedKeys(
      logisticTypes.map((logisticType) => ({
        ...logisticType,
        items: logisticType.items?.map((item) => item),
        selected: true,
      })),
    );

    return selectedKeys;
  });

  const activeLogisticTypesTreeViewItems = useMemo<TreeItemType<number>[]>(() => {
    return logisticTypes.map((item) => ({ ...item, selected: true }));
  }, [logisticTypes]);

  const logisticIds = useMemo(() => selectedLogisticTypes.filter((type) => type), [selectedLogisticTypes]);

  return {
    activeLogisticTypesTreeViewItems,
    setSelectedLogisticTypes,
    logisticIds,
  };
}
